import React from 'react';
import env from '../../environment.js';
import './map-controls.css';

export const MAP_TYPE_OPTIONS = [
  { value: 'roadmap', label: 'Plano' },
  { value: 'terrain', label: 'Terreno' },
  { value: 'satellite', label: 'Satélite' },
  { value: 'hybrid', label: 'Híbrido' },
];

const MapTypeToggle = ({ value, onChange, options = MAP_TYPE_OPTIONS, ariaLabel = 'Tipo de mapa' }) => (
  <div
    className="d-flex no-print"
    role="group"
    aria-label={ariaLabel}
    style={{ backgroundColor: env.colors.neutral_1, borderRadius: 10, padding: 3 }}>
    {options.map(opt => {
      const selected = value === opt.value;
      return (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          aria-pressed={selected}
          className={`btn btn-sm map-type-toggle-btn${selected ? ' map-type-toggle-active' : ''}`}
          style={{
            borderRadius: 8,
            backgroundColor: selected ? env.colors.neutral_900 : 'transparent',
            border: 0,
            fontWeight: 600,
            padding: '6px 14px',
            transition: 'background-color 200ms ease, color 200ms ease',
          }}>
          {opt.label}
        </button>
      );
    })}
  </div>
);

export default MapTypeToggle;
